export default {
  Title: 'Patho Report Resend',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  DateReleaseFrom: 'Date Release From',
  DateReleaseTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  ReportType: 'Report Type',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  ReleaseDate: 'Release Date',
  Find: 'Find',
  Resend: 'Resend',
  Sex: 'Sex',
  Status: 'Status',
  HN: 'HN',
  SentToHis: 'Sent to HIS',
  ResendUser: 'Resend User',
  ResendDate: 'Resend Date',
  ResendCount: 'Resend Count',
}
